import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchDashboardFeatures } from "services/api/dashboard";
import { AuthState } from "slices/auth/reducer";
import { DashboardState, Features } from "types/dashboard";
import { isFresh } from "utils/helpers";

export const fetchDashboardFeaturesThunk = createAsyncThunk<{ features: Features | null, cached?: boolean }, { force?: boolean }, { rejectValue: string }>(
    'dashboard/features',
    async ({ force = false }, { getState, rejectWithValue }) => {
        try {
            const state = getState() as { auth: AuthState, dashboard: DashboardState };
            const STALE_TIME = apiConfig.FETCH_DASHBOARD_FEATURES.staleTime;
            const features = state.dashboard.features;
            if (
                features.completed &&
                features.items &&
                !force &&
                isFresh(features.last_fetched_at, STALE_TIME)
              ) {
                return { features: features.items, cached: true };
              }
            const agencyId = state.auth.selectedAgency?.uuid ?? '';
            if (!agencyId) throw new Error("No agency selected!");
            const { features: f } = await fetchDashboardFeatures(agencyId);
            return { features: f };
        } catch (error) {
            return rejectWithValue("failed to fetch dashboard features");
        }
    }
)